import React, { useState, useEffect } from 'react'
import { Dropdown, Form, Button, FormControl, Row, Col, ListGroup, OverlayTrigger } from 'react-bootstrap'
import { CustomToggle } from '../../_reusedcomponents/CustomDropDown'
import {MaintainStockListView} from './MaintainStockListView'
import '../../../index.css'
import { SizesControl } from './SizesControlView'
import { sizeValues } from './SizesControlView'
import { FetchTransactionInfos, FetchArticleTypeImages } from '../../../fetcher'
import LoadingSpinner from '../../_reusedcomponents/LoadingSpinner'
import AlertMessage from '../../alertmessages/AlertMessageView'
import { DescriptionTooltipView } from '../../_reusedcomponents/DescriptionTooltipView'
import { RenderImage } from '../../images/ImageView'
import { parseFloatCurrency } from '../../../utils/formatting/floatnumberparsing'
import { useHandleAlertMessage } from '../../../utils/togglinghooks'

let numberInputs = []
let sizeCategory
let articleEntry
let articleSysId
let articleIdFaex
let salePrice
let image
let articleDropdown

/**
 * Creates a transaction of type new arrival to maintain the stock.
 * Can be merges with CreateTransactionContainer.
 * @param {any} handleCloseMask handles closing its mask from parent
 * @param {any} lowerStock defines if values are going to be added or removed fron stock
 * @param {any} reloadParent event for reloading parent container
 * @param {object} [draft] set if container is called with a saved draft to update
 */
const MaintainStockContainer = ({ handleCloseMask, lowerStock = false, reloadParent, draft = null }) => {
    const [articles, setArticles] = useState([])
    const [sizeCats, setSizeCats] = useState([])
    const articleHeaderDefault = window.i18n('selectArticleType')
    const [articleNameHeader, setArticleNameHeader] = useState(articleHeaderDefault)
    const [uiError, setError] = useState(false)

    const [addToStock, setAddToStock] = useState([])
    const [remark, setRemark] = useState("")
    const [isDraftUpdate, setIsDraftUpdate] = useState(false)

    const [showSizes, setShowSizes] = useState([])
    const [articleTypeName, setArticleTypeName] = useState("")
    const { showAlertMessage, closeAlert, openAlert } = useHandleAlertMessage()

    const [articleDropDownShow, setArticleDropDownShow] = useState(false)

    const [articleFilterInput, setArticleFilterInput] = useState("")
    const handleArticleFilter = (e) => {
        setArticleFilterInput(e.target.value)
    }

    const [articleDataReady, setArticleDataToReady] = useState(false)

    /**
     * Adds the corresponding images to the fetched articleTypes via SysIds.
     * @param {object[]} articleTypeImages image datas as binary string
     */
    const addingImages = (articleTypeImages) => {
        let copiedArticleData = [...articles]
        articleTypeImages.forEach(image => copiedArticleData.find(x => x.Articles.ArticleTypeSysId == image.ArticleTypeSysId).Articles.Image = 'data:image/png;base64,' + image.Data)
        setArticles(copiedArticleData)
    }

    /**
     * UseEffect hook to fetch transaction infos after rendering
     * If a draft was passed, set transaction datas to the ones already saved in the draft
    */
    useEffect(() => {
        FetchTransactionInfos(setArticles, setSizeCats, openAlert, setArticleDataToReady)

        if (draft !== null) {
            setRemark(draft.Remark)
            setIsDraftUpdate(true)

            let newAddStock = [...addToStock]

            draft.Articles.forEach(article => {
                if (newAddStock.find(x => x.sizeCat == article.SizeCat) == null)
                    newAddStock.push({ sizeCat: article.SizeCat, articleTypes: [] })
                if (newAddStock.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId) == null)
                    newAddStock.find(x => x.sizeCat == article.SizeCat).articleTypes.push({ articleName: article.Name, articleSysId: article.ArticleTypeSysId, articleIdFaex: article.ArticleIdFaex, salePrice: article.SalePrice, image: article.Image, sizeEntries: [] })
                article.Sizes.forEach(z =>
                (newAddStock.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.find(x => x.SizeValue == z.SizeValue) == null
                    ? newAddStock.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.push({ SizeValue: z.SizeValue, Amount: parseInt(z.Amount) })
                    : newAddStock.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.find(x => x.SizeValue == z.SizeValue).Amount += parseInt(z.Amount)))
            }
            )

            setAddToStock(newAddStock)
        }
    }, []);

    /**
     * Fetches images for articleTypes via SysIds if they are already fetched
    */
    useEffect(() => {
        if (articleDataReady) {
            FetchArticleTypeImages(articles.map(x => x.Articles.ArticleTypeSysId.toString()), addingImages, openAlert)
        }
    }, [articleDataReady])

    /**
     * sets UI focus on the dropdown
    */
    const setFocus = () => {
        articleDropdown.focus()
    }

    /**
     * Sets references on article which is going to be added to the transaction
     * @param {any} e default click event
     * @param {object} article article infos needed to identify which article is going to be addad
     */
    const handleChange = (e, article) => {
        if (e !== null) e.preventDefault()
        setArticleNameHeader(article != null ? article.Articles.Name : articleHeaderDefault)
        setArticleDropDownShow(false)

        if (article != null && article != undefined && article.Articles != undefined) {
            sizeCategory = article.SizeCat
            articleSysId = article.Articles.ArticleTypeSysId
            articleIdFaex = article.Articles.ArticleIdFaex
            salePrice = article.Articles.SalePrice
            image = article.Articles.Image

            setArticleTypeName(article.Articles.Name)
            setShowSizes(article.Articles.SizeValues)
        } else {
            sizeCategory = ""
            setArticleTypeName("")
            setShowSizes([])
        }
    }

    /**
     * Submits new transaction data into the stock.
     * Checks tree-like structure of stock to identify what is already set in the transaction; updates the rest
     * Resets the list view afterwards
     * @param {any} e default click event
     */
    const submitAddToStock = (e) => {
        e.preventDefault()

        if (sizeValues.some(x => parseInt(x.amount) != 0)) {
            let newStock = [...addToStock]

            if (newStock.find(x => x.sizeCat == sizeCategory) == null)
                newStock.push({ sizeCat: sizeCategory, articleTypes: [] })
            if (newStock.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId) == null)
                newStock.find(x => x.sizeCat == sizeCategory).articleTypes.push({ articleName: articleNameHeader, articleSysId: articleSysId, articleIdFaex: articleIdFaex, salePrice: salePrice, image: image, sizeEntries: [] })
            sizeValues.forEach(z =>
            (newStock.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.find(x => x.SizeValue == z.size.SizeValue) == null
                ? newStock.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.push({ SizeValue: z.size.SizeValue, Amount: parseInt(z.amount) })
                : newStock.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.find(x => x.SizeValue == z.size.SizeValue).Amount += parseInt(z.amount)))

            setAddToStock(newStock)

            handleChange(null, null)
            setArticleTypeName("")
            setShowSizes([])
            setError(false)
        } else {
            setError(true)
        }

        setFocus()
    }

    /**
     * Renders the sizes and input fields.
    */
    const renderOrderInput = () => {
        return (
            <div className="form-inline order-input">
                <SizesControl showSizes={showSizes} articleTypeName={articleTypeName} />
                <Button variant="secondary" className="form form-inline order-input order-input-button" type="submit"> ✓ </Button>
            </div>
        )
    }

    /**
     * Renders an error message if neccessary.
    */
    const renderErrorMessage = () => {
        return (<div className="error">{window.i18n('errorEmptyValue')}</div>)
    }

    /**
     * Removes a specific entry of the transaction order.
     * @param {any} e default click event
     * @param {any} sizeCat sizeCategory of orderEntry to be removed
     * @param {any} articleEntry articleEntry to be removed
     */
    const removeOrderEntry = (e, sizeCat, articleEntry) => {
        e.preventDefault()

        let removeFromStock = [...addToStock]

        removeFromStock.forEach(function (sizeCat) {
            sizeCat.articleTypes = sizeCat.articleTypes.filter(x => x.articleSysId != articleEntry.articleSysId)
        });
        removeFromStock = removeFromStock.filter(x => x.articleTypes.length > 0)

        setAddToStock(removeFromStock)
    }

    /**
     * Resets order entries completely.
    */
    const resetOrderEntries = () => {
        setAddToStock([])
    }

    return (
        <div>
            <Form onSubmit={submitAddToStock}>

                <Dropdown className="form" >
                    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" ref={node => articleDropdown = node} onClick={() => setArticleDropDownShow(!articleDropDownShow)}>
                        {articleNameHeader}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="article-dropdown" show={articleDropDownShow} rootCloseEvent=''>

                        <FormControl className="globalSearch-deliveryOrder" as="input" placeholder={window.i18n('articleName') + "..."} value={articleFilterInput} onChange={handleArticleFilter}></FormControl>

                        <div className="dropdown-listGroup">
                            {articles.filter(x => (x.Articles.Name.toLowerCase().includes(articleFilterInput.toLowerCase()) || x.Articles.ArticleNumberDesigner.toLowerCase().includes(articleFilterInput.toLowerCase()) || x.Articles.ArticleIdFaex.toLowerCase().includes(articleFilterInput.toLowerCase())))
                                .sort((a, b) => a.Articles.Name.localeCompare(b.Articles.Name))
                                .map(article =>

                                    <ListGroup.Item className="dropdown-listGroup-item" value={article.Articles.Name} action onClick={(e) => handleChange(e, article)}>
                                        <Row >
                                            <Col className="dropdown-imageColumn">{RenderImage(article.Articles.Image)}</Col>
                                            <Col >{article.Articles.Name}</Col>
                                            <Col className="dropdown-article-smallField">{article.Articles.ArticleIdFaex}</Col>
                                            <Col >{article.Articles.ArticleNumberDesigner}</Col>
                                            <Col >{article.Articles.Colour}</Col>
                                            <Col className="dropdown-article-smallField">{parseFloatCurrency(article.Articles.SalePrice)}</Col>
                                            <OverlayTrigger trigger="hover" placement="top" overlay={DescriptionTooltipView(article.Articles.DescriptionDesigner)}>
                                                <Col className="dropdown-article-description">{article.Articles.DescriptionDesigner}</Col>
                                            </OverlayTrigger>
                                        </Row>
                                    </ListGroup.Item>
                                )
                            }
                        </div>

                        <LoadingSpinner />
                        <Dropdown.Divider />
                    </Dropdown.Menu>
                </Dropdown >

                {articleNameHeader !== articleHeaderDefault ?
                    renderOrderInput() : <div className="placeholder">empty</div>
                }

                {uiError && renderErrorMessage()}

            </Form>

            <MaintainStockListView removeOrderEntry={removeOrderEntry} addToStock={addToStock} lowerStock={lowerStock} remark={remark} resetOrderEntries={resetOrderEntries} handleCloseMask={handleCloseMask} reloadParent={reloadParent} isDraftUpdate={isDraftUpdate} draftSysId={draft !== null ? draft.TransactionSysId : null} />

            <Form className="remark-form">
                <Form.Group className="mb-3">
                    <Form.Label>{window.i18n('annotationStock')}</Form.Label>
                    <Form.Control as="textarea" defaultValue={draft !== null ? draft.Remark : ""} rows={3} onChange={(e) => setRemark(e.target.value)} />
                </Form.Group>
            </Form>

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}

export { MaintainStockContainer }